import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import api from '../../services/api'
import { toast } from 'react-toastify'
import { FaSearch } from 'react-icons/fa'
import { useInView } from 'react-intersection-observer'
import loader from '../../assets/images/page-img/page-load-loader.gif'
import { debounce } from 'lodash'
import io from 'socket.io-client'
import AnimationWarningLottie from "../../components/AnimationWarningDeleteConfim/AnimationWarningLottie";

const FriendList = () => {
  const token = Cookies.get('token')
  const loged_user = Cookies.get('userId')
  const [Friends, setFriends] = useState([])
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.1,
  })

  const [modalShow, setModalShow] = useState(false);
  const [friendIdToDelete, setFriendIdToDelete] = useState(null);
  const [friendNameToDelete, setFriendNameToDelete] = useState("");

  const socket = io(process.env.REACT_APP_API_SOCKET_URL, {
    autoConnect: true,
    withCredentials: true,
  })

  const fetchData = useCallback(async (resetPage = false) => {
    setIsLoading(true)
    const currentPage = resetPage ? 1 : page
    try {
      const response = await api.post(`/api/friendsPaginated/show`, {
        loged_user,
        token,
        search,
        page: currentPage,
        limit: 10
      })
      const data = response.data.data
      if (resetPage) {
        setFriends(data)
        setPage(2)
      } else {
        setFriends(prev => [...prev, ...data])
        setPage(currentPage + 1)
      }
      setHasMore(data.length === 10)
    } catch (error) {
      console.error('Failed to fetch user data:', error)
    } finally {
      setIsLoading(false)
    }
  }, [search, page, loged_user, token])

  const handleSearchChange = useCallback(debounce((newSearch) => {
    setSearch(newSearch)
    fetchData(true)
  }, 300), [])

  useEffect(() => {
    fetchData(true)
  }, [search])

  useEffect(() => {
    if (inView && hasMore && !isLoading) {
      fetchData(false)
    }
  }, [inView, hasMore, isLoading])

  const showDeleteFriendConfirmationModal = (friendId, friendName) => {
    setModalShow(true);
    setFriendIdToDelete(friendId);
    setFriendNameToDelete(friendName);
  };

  const deleteFriend = async () => {
    setIsDeleting(true);
    try {
      await api.post(`/api/friends/remove`, { friendId: friendIdToDelete, loged_user }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Amigo removido com sucesso!', { autoClose: 1000 });
      setFriends(prev => prev.filter(f => f.id !== friendIdToDelete));
      setModalShow(false);
    } catch (error) {
      console.error('Erro ao remover amigo:', error);
      toast.error('Erro ao remover amigo.', { autoClose: 3000 });
    } finally {
      setIsDeleting(false);
    }
  };

  function DeleteFriendConfirmationModal(props) {
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Amigo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-center">
            <AnimationWarningLottie />
          </div>
          <div className="d-flex justify-content-center">
            <p>Deseja remover "<strong>{props.friendName}</strong>" da sua lista de amigos?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={deleteFriend} variant="danger" disabled={isDeleting}>
            {isDeleting ? (
              <div className="spinner-border spinner-border-sm" role="status"></div>
            ) : (
              'Sim'
            )}
          </Button>
          <Button onClick={props.onHide} variant="secondary">Não</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const filteredFriends = useMemo(() => {
    return search ? Friends.filter(f => f.name.toLowerCase().includes(search.toLowerCase())) : Friends
  }, [search, Friends])


  return (
    <>
      <div id='content-page' className='content-inner'>
        <Container>
          <Row>
            <Col sm='12'>
              <Card className='position-relative inner-page-bg bg-primary p-5 align-center'>
                <div className='inner-page-title' style={{ display: 'flex', justifyContent: 'space-between', width: '-webkit-fill-available' }}>
                  <h3 className='text-white'>Meus Amigos</h3>
                  <Link to='/' className='text-white py-1 px-2'>
                    <i className='icon material-symbols-outlined d-flex'>arrow_back</i>
                  </Link>
                </div>
              </Card>
              <div className='mb-4 mt-4'>
                <Form.Group className='input-group'>
                  <span className='input-group-text' id='basic-addon1'><FaSearch /></span>
                  <Form.Control
                    placeholder='Pesquisar'
                    aria-label='Pesquisar'
                    aria-describedby='search'
                    onChange={(e) => handleSearchChange(e.target.value)}
                  />
                </Form.Group>
              </div>
              <ul className="request-list list-inline m-0 p-0">
                {filteredFriends.map((friend, index) => (
                  <li className="d-flex align-items-center justify-content-between mb-4" md={12} key={index} ref={index === filteredFriends.length - 1 ? ref : null}>
                    <div className="d-flex align-items-center">
                      <div className="user-img img-fluid flex-shrink-0">
                        <img
                          src={friend.user_about.image_profile}
                          alt="story-img"
                          className="rounded-circle avatar-40"
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <Link to={`/users/profile/${friend.id}`} >
                          {friend.name}
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mt-2 mt-md-0">
                      <div className="confirm-click-btn">
                        <Button onClick={() => showDeleteFriendConfirmationModal(friend.id, friend.name)} className="me-2 btn btn-danger-subtle rounded confirm-btn p-1 lh-1">
                          <i className="material-symbols-outlined font-size-14">
                            close
                          </i>
                        </Button>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
              {isLoading && <div className='col-sm-12 text-center'>
                <img src={loader} alt='loader' style={{ height: '100px' }} />
              </div>}
            </Col>
          </Row>
        </Container>
      </div>
      <DeleteFriendConfirmationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        friendName={friendNameToDelete}
      />
    </>

  )
}

export default FriendList
